import { request } from "../../platform/apiClient/apiRequest";
import type { PolicyDivision, PolicyDocument } from "../types/policyDocument.types";

export const policyDocumentsClient = {
  getDocuments: () => request<PolicyDocument[]>("/policies/documents"),

  uploadDocument: (file: File, division: PolicyDivision) =>
    request<PolicyDocument>(
      `/policies/admin/documents?filename=${encodeURIComponent(file.name)}&division=${encodeURIComponent(division)}`,
      {
        method: "POST",
        headers: { "Content-Type": file.type || "application/octet-stream" },
        body: file,
      },
    ),

  deleteDocument: (id: string) => request<void>(`/policies/admin/documents/${encodeURIComponent(id)}`, { method: "DELETE" }),

  updateDivision: (id: string, division: PolicyDivision) =>
    request<PolicyDocument>(`/policies/admin/documents/${encodeURIComponent(id)}/division`, {
      method: "PATCH",
      body: JSON.stringify({ division }),
    }),
};

/** Direct download link — not fetched via JS, used as an <a href>. */
export function policyDocumentDownloadUrl(id: string): string {
  return `/api/policies/documents/${encodeURIComponent(id)}/file`;
}
